/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Checkout } from './Checkout';
import {
    CheckoutFromJSON,
    CheckoutFromJSONTyped,
    CheckoutToJSON,
} from './Checkout';
import type { Payment } from './Payment';
import {
    PaymentFromJSON,
    PaymentFromJSONTyped,
    PaymentToJSON,
} from './Payment';

/**
 * 
 * @export
 * @interface CreateCheckout201ResponseAllOfData
 */
export interface CreateCheckout201ResponseAllOfData {
    /**
     * 
     * @type {Checkout}
     * @memberof CreateCheckout201ResponseAllOfData
     */
    checkout: Checkout;
    /**
     * 
     * @type {Payment}
     * @memberof CreateCheckout201ResponseAllOfData
     */
    payment: Payment;
}

/**
 * Check if a given object implements the CreateCheckout201ResponseAllOfData interface.
 */
export function instanceOfCreateCheckout201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkout" in value;
    isInstance = isInstance && "payment" in value;

    return isInstance;
}

export function CreateCheckout201ResponseAllOfDataFromJSON(json: any): CreateCheckout201ResponseAllOfData {
    return CreateCheckout201ResponseAllOfDataFromJSONTyped(json, false);
}

export function CreateCheckout201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckout201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkout': CheckoutFromJSON(json['checkout']),
        'payment': PaymentFromJSON(json['payment']),
    };
}

export function CreateCheckout201ResponseAllOfDataToJSON(value?: CreateCheckout201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout': CheckoutToJSON(value.checkout),
        'payment': PaymentToJSON(value.payment),
    };
}

